import { SafeError, SafePromise } from '@benzinga/safe-await';
import { ListenableSubscribable } from '@benzinga/subscribable';
import { QuotesV3FieldsRestful } from './restful';
import { Session } from '@benzinga/session';
import { DataFieldIngress } from './entities';

interface ErrorEvent {
  error?: SafeError | Response;
  errorType: 'get_scanner_instruments_error';
  type: 'error';
}

export type QuotesV3FieldsRequestEvent = ErrorEvent;
export class QuotesV3FieldsRequest extends ListenableSubscribable<QuotesV3FieldsRequestEvent> {
  private restful: QuotesV3FieldsRestful;

  constructor(session: Session) {
    super();
    this.restful = new QuotesV3FieldsRestful(session);
  }

  public getScannerDefs = async (): SafePromise<DataFieldIngress> => {
    const response = await this.restful.getScannerDefs();

    if (response.err) {
      try {
        this.dispatch({
          error: response.err,
          errorType: 'get_scanner_instruments_error',
          type: 'error',
        });

        return { err: response.err };
      } catch (e) {
        return { err: new SafeError('Failed to decode error', 'unknown', e) };
      }
    } else {
      return response;
    }
  };
}
